import type { ApiRes, HeadersOptionType } from '@/uTypes/api'

/**
 * ! Http Fetch Interfaces !
 * ! Return Url !
*/
export function getApiUrl (ver:string = 'v1') {
  return useRuntimeConfig().public.apiUrl + `/esim/${ver}/`
}

export const useHttp = (ver:string = 'v1') => {
  const { userAuth } = storeToRefs(useAuthStore())

  const get = async <Res>(url: string, headers?: HeadersOptionType): Promise<Res> => {
    return await $fetch<Res>(url, {
      method: 'GET',
      baseURL: getApiUrl(ver),
      credentials: 'include',
      headers: {
        'content-type': 'application/json',
        authorization: `Bearer ${userAuth.value}`,
        ...headers
      }
    }).catch((error) => {
      if (error?.statusCode === 401) {
        userAuth.value = null
      }
      return error.data
    })
  }

  const authPost = async (url:string) => {
    return await $fetch(url, {
      method: 'POST',
      baseURL: getApiUrl(ver),
      credentials: 'include',
      headers: { 'content-type': 'application/json' }
    }).catch((error) => {
      return error.data
    })
  }

  const post = async (url:string, params:any) => {
    return await $fetch(url, {
      method: 'POST',
      baseURL: getApiUrl(ver),
      credentials: 'include',
      headers: {
        'content-type': 'application/json',
        authorization: `Bearer ${userAuth.value}`
      },
      body: params
    }).catch((error) => {
      return error.data
    })
  }

  const rawPost = async (url:string, headers?: HeadersOptionType) => {
    return await $fetch(url, {
      method: 'POST',
      baseURL: getApiUrl(ver),
      credentials: 'include',
      headers: {
        'content-type': 'application/json',
        authorization: `Bearer ${userAuth.value}`,
        ...headers
      }
    }).catch((error) => {
      return error.data
    })
  }

  const patch = async <Res>(url:string, payload:any): Promise<ApiRes<Res>> => {
    return await $fetch<ApiRes<Res>>(url, {
      method: 'PATCH',
      baseURL: getApiUrl(ver),
      credentials: 'include',
      headers: {
        'content-type': 'application/json',
        authorization: `Bearer ${userAuth.value}`
      },
      body: payload
    }).catch((error) => {
      return error.data
    })
  }

  const rawPatch = async (url:string) => {
    return await $fetch(url, {
      method: 'PATCH',
      baseURL: getApiUrl(ver),
      credentials: 'include',
      headers: {
        'content-type': 'application/json',
        authorization: `Bearer ${userAuth.value}`
      }
    }).catch((error) => {
      return error.data
    })
  }

  const put = async (url:string) => {
    return await $fetch(url, {
      method: 'PUT',
      baseURL: getApiUrl(ver),
      credentials: 'include',
      headers: {
        'content-type': 'application/json',
        authorization: `Bearer ${userAuth.value}`
      }
    }).catch((error) => {
      return error.data
    })
  }

  const del = async (url:string) => {
    return await $fetch(url, {
      method: 'DELETE',
      baseURL: getApiUrl(ver),
      credentials: 'include',
      headers: {
        'content-type': 'application/json',
        authorization: `Bearer ${userAuth.value}`
      }
    }).catch((error) => {
      return error.data
    })
  }

  return {
    get,
    authPost,
    post,
    rawPost,
    patch,
    rawPatch,
    put,
    del
  }
}
